import { useAppTheme } from "@hooks/useAppTheme";
/* -----------------Globals--------------- */
import { Image } from "expo-image";

type Props = {
	image: string;
	size: number;
	enabledBoxShadow?: boolean;
	showBorder?: boolean;
};

const ProductIcon = (props: Props) => {
	const { size, image, showBorder = true } = props;
	const theme = useAppTheme();

	return (
		<Image
			source={{ uri: image }}
			style={{
				width: size,
				height: size,
				borderRadius: size * 0.22,
				borderWidth: showBorder ? size * 0.02 : 0,
				borderColor: theme.colors.onPrimaryContainer,
			}}
			cachePolicy={"memory"}
			contentFit="contain"
			alt={"Product Icon"}
			accessibilityLabel={"Product Icon"}
		/>
	);
};

export default ProductIcon;
